import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BdsSplcErpcService } from '@bds/data-access';
import { DxDataGridComponent } from 'devextreme-angular/ui/data-grid';
import DataSource from 'devextreme/data/data_source';

@Component({
    selector: 'bds-bds-splc-select-dialog',
    templateUrl: './bds-splc-select-dialog.component.html',
    styleUrls: ['./bds-splc-select-dialog.component.css'],
})
export class BdsSplcSelectDialogComponent implements OnInit {
    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    dataSource: DataSource;
    selectedRowKeys: string;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialogRef: MatDialogRef<BdsSplcSelectDialogComponent, any>,
        private splcService: BdsSplcErpcService,
    ) {}

    ngOnInit(): void {
        this.dataSource = new DataSource({
            store: this.splcService.getODataStore(),
            paginate: true,
            pageSize: 15,
            select: ['splc', 'erpcCity', 'erpcState', 'city', 'state', 'rule260'],
        });
        this.dataSource.filter(this.data.filter);
    }

    onSelectClick(): void {
        const data = this.dataGrid.instance.getSelectedRowsData();
        if (data.length > 0) {
            this.dialogRef.close(data);
        }
    }
}
